import type { OutpatientClinicTaskListFilter } from '../types/outpatientClinicTaskListFilter';

export const emptyOutpatientClinicTaskListFilter: OutpatientClinicTaskListFilter = {
    category: undefined,
    endDate: undefined,
    episodeCategory: undefined,
    performerPractitioner: undefined,
    performerPractitionerProfession: undefined,
    searchText: undefined,
    startDate: undefined,
    type: undefined,
} as const;
